import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { GetBannerModel } from '../../../../shared/api-models/responses/banner/GetBannners';
@Injectable({
  providedIn: 'root',
})
export class GetBannerService {
  constructor(private baseClient: BaseHttpClientService) { }

  call(grade_id: string, banner_place) {
    return this.baseClient.getWithAuth<any>(
      `/api/v1/banner/get_banners/${grade_id}/${banner_place}`
    );
  }
}
